// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{ label:'业务日期：',xs:24,sm:12,md:12,lg:8,xl:8,type:'date',modelValue:'busDate',disabled:true},
	{ label:'发票日期：',xs:24,sm:12,md:12,lg:8,xl:8,type:'date',modelValue:'invoDate',prop:'phayId',placeholder:''},
	{ label:'终端序号：',xs:24,sm:12,md:12,lg:8,xl:8,type:'input',modelValue:'terminalId',prop:'terminalId',disabled:true},
	
	{ label:'出库库房：',xs:24,sm:24,md:12,lg:8,xl:8,type:'select',modelValue:'shedId',prop:'shedId',op:'selectOption'},
	{ label:'收货库房：',xs:24,sm:24,md:12,lg:8,xl:8,type:'select',modelValue:'phayId',prop:'phayId',op:'optionks'},
	{ label:'供货单位：',xs:24,sm:8,md:12,lg:8,xl:8,type:'select',modelValue:'supplyCandidateId',op:'gysOption'},
	
	{ label:'备注：',xs:24,sm:24,md:24,lg:24,xl:24,type:'textarea',modelValue:'remarks',placeholder:'',},
	
]

